var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 15C11.1562 15 11 14.8438 11 14.625V7.875C11 7.6875 11.1562 7.5 11.375 7.5H12.125C12.3125 7.5 12.5 7.6875 12.5 7.875V14.625C12.5 14.8438 12.3125 15 12.125 15H11.375ZM16.5 4.5C16.75 4.5 17 4.75 17 5V5.5C17 5.78125 16.75 6 16.5 6H16V16.5C16 17.3438 15.3125 18 14.5 18H5.5C4.65625 18 4 17.3438 4 16.5V6H3.5C3.21875 6 3 5.78125 3 5.5V5C3 4.75 3.21875 4.5 3.5 4.5H6.0625L7.125 2.75C7.375 2.3125 7.875 2 8.40625 2H11.5625C12.0938 2 12.5938 2.3125 12.8438 2.75L13.9062 4.5H16.5ZM8.34375 3.59375L7.8125 4.5H12.1562L11.625 3.59375C11.5938 3.5625 11.5312 3.5 11.4688 3.5H8.53125C8.5 3.5 8.5 3.5 8.5 3.5C8.4375 3.5 8.375 3.5625 8.34375 3.59375ZM14.5 16.5V6H5.5V16.5H14.5ZM7.875 15C7.65625 15 7.5 14.8438 7.5 14.625V7.875C7.5 7.6875 7.65625 7.5 7.875 7.5H8.625C8.8125 7.5 9 7.6875 9 7.875V14.625C9 14.8438 8.8125 15 8.625 15H7.875Z",
    fill: "#FA0B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.ac13224c8d983a47a27f2ee0c8307b7f.svg";
export { ForwardRef as ReactComponent };